export const emptyPaginationPayload = {
  page: 1,
  hasNextPage: false,
  items: [],
  totalItems: 0,
  totalPages: 1,
};
